/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useMemo, useState } from 'react';
import TableLayout from 'components/atoms/TableLayout';
import Table from 'components/molecules/Table';
import transactionService from 'services/transactionService';
import Loaders from 'components/atoms/Loaders';
import { formatCurrency } from 'helpers/common';
import logo from '../../../assets/images/logo-dark.svg';
import userIcon from '../../../assets/images/userIcon.svg';
import number from '../../../assets/images/number.svg';
import time from '../../../assets/images/time.svg';
import { StatementStyled } from './StatementDetails.styles';
import 'styled-components/macro';

function StatementDetailsV2({
  report_id,
  responsive = false,
  print,
  year = new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
  month = new Date().getMonth() === 0 ? 12 : new Date().getMonth(),
}) {
  // eslint-disable-next-line no-param-reassign
  // report_id = '1362000079';
  const { report_new, report_new_loading } = transactionService.GetReportDetailsNew(report_id, year, month);
  const summaryColumnNames = [
    'Card Type',
    'Number of Sales',
    'Sales',
    'Number Of Credits',
    'Credits',
    'Total Transactions',
    'Interchange Fee',
    'Net Sales',
    'Total',
  ];

  const feesummaryColumnNames = ['Fee Types', 'Total Charges'];

  const summary_rows = useMemo(
    () =>
      report_new?.salesSummary?.map(summary => [
        summary['Card Scheme'],
        summary['Sales #'],
        formatCurrency(summary['Sales $']),
        summary['Credits/Refunds #'],
        formatCurrency(Number(summary['Credits/Refunds $'])),
        summary['Sales #'] + summary['Credits/Refunds #'],
        formatCurrency(summary['Interchange Fee ($)']),
        formatCurrency(summary['Net Sales ($)']),
        formatCurrency(summary['Total ($)']),
      ]),
    [report_new_loading, report_new],
  );

  const fee_summary_rows = useMemo(
    () => [
      ['Card Type Charges', formatCurrency(report_new?.interchangeAndAcquirerFees?.['Total I/C and Wholesale Fees'])],
      [
        'Other Fees & Charges',
        formatCurrency(report_new?.monthlyFeesAndTaxes?.reduce((acc, _) => acc + (_['Total Fee Amount'] ?? 0), 0)),
      ],
    ],
    [report_new],
  );

  const funding_summary_col = ['Date', 'Card Type', 'Transaction Amount', 'Count'];
  const [state, setState] = useState({
    page: 1,
    pageSize: 10,
  });
  useEffect(() => {
    if (responsive && Object.keys(report_new ?? {}).length) {
      setState({ page: 1, pageSize: report_new?.deposits?.length });
      setTimeout(() => {
        const [printContents] = document.getElementsByClassName('print_div');
        document.body.innerHTML = printContents.innerHTML;
        window.print();
        window.location.reload();
      }, 300);
    }
  }, [report_new_loading]);

  // useEffect(() => {
  //   if (state.page > 1) {
  //     setState({ ...state, pageSize: 20 });
  //   } else {
  //     setState({ ...state, pageSize: 5 });
  //   }
  // }, [state.page]);
  // eslint-disable-next-line default-param-last
  const pagination = (data = [], { page, pageSize }) => {
    const start = (page - 1) * pageSize;
    const end = page * pageSize;
    return data.slice(start, end);
  };
  const funndingSummary = useMemo(
    () =>
      pagination(
        report_new?.deposits?.map(_ => [_?.Date, _?.['Card Scheme'], formatCurrency(_?.Amount), _.Count]),
        state,
      ),
    [report_new?.deposits, state],
  );

  return (
    <Loaders loading={report_new_loading}>
      <StatementStyled id="dashboard-container">
        <div className="modal-head">
          <div className="logo-title-holder">
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
            <strong className="heading">Monthly Merchant Statement Details!</strong>
          </div>
          <div className="info-col">
            <div className="column">
              <div className="col">
                <div className="image-holder">
                  <img src={userIcon} alt="Icon" />
                </div>
                <strong className="title">{report_new?.merchantName ?? 'n/a'}</strong>
              </div>
              <div className="col">
                <div className="image-holder">
                  <img src={number} alt="Icon" />
                </div>
                <strong className="title">{report_new?.merchantNumber ?? 'n/a'}</strong>
              </div>
            </div>
            <div className="column">
              <div className="col">
                <div className="image-holder">
                  <img src={time} alt="Icon" />
                </div>
                <strong className="title">Billing period: {report_new?.statementPeriod}.</strong>
              </div>
            </div>
          </div>
        </div>
        <div className="paragraph">
          <p>
            If you have any questions regarding your statement, please contact: 1-800-848-2974 or e-mail:
            merchantservices@pspservicesco.com.Any discrepancies must be brought to our attention within 60 days from
            the date of statement. All amounts in Canadian Dollars. Rounding differences may occur during calculation of
            fees. EDMR = Effective Merchant Discount Rate, For more information on interchange or the interchange fee
            descriptors, please visit <a href="https://www.pspservicesco.com">www.pspservicesco.com</a>
          </p>
        </div>
        {state.page === 1 && (
          <div>
            <div className="table-wrap">
              <strong className="tables-heading">Fee Summary</strong>
              <span
                css={`
                  font-size: 1.2rem;
                  font-weight: 600;
                  margin-left: 20px;
                `}>
                Fee Summary Total:{' '}
                {formatCurrency(
                  (report_new?.interchangeAndAcquirerFees?.['Total I/C and Wholesale Fees'] ?? 0) +
                    report_new?.monthlyFeesAndTaxes?.reduce((acc, _) => acc + (_['Total Fee Amount'] ?? 0), 0),
                )}
              </span>
              <TableLayout noNegativeMargin isSearchBar={false} currentPage={15}>
                <Table
                  center
                  responsive={!responsive}
                  noPadding
                  rowsData={fee_summary_rows}
                  columnNames={feesummaryColumnNames}
                />
              </TableLayout>
            </div>
            <div className="table-wrap">
              <strong className="tables-heading">Card Type Summary</strong>
              <span
                css={`
                  font-size: 1.2rem;
                  font-weight: 600;
                  margin-left: 20px;
                `}>
                Card Type Summary Total:{' '}
                {formatCurrency(report_new?.salesSummary?.reduce((acc, _) => acc + Number(_['Total ($)']), 0))}
              </span>

              <TableLayout noNegativeMargin isSearchBar={false} currentPage={15}>
                <Table
                  center
                  responsive={!responsive}
                  noPadding
                  rowsData={summary_rows}
                  columnNames={summaryColumnNames}
                />
              </TableLayout>
            </div>
          </div>
        )}

        {state.page === 1 && (
          <div className="table-wrap">
            <strong className="tables-heading">Card Type Charges</strong>
            <span
              css={`
                font-size: 1.2rem;
                font-weight: 600;
                margin-left: 20px;
              `}>
              Card Type Charge Fees Total:{' '}
              {formatCurrency(report_new?.interchangeAndAcquirerFees?.['Total I/C and Wholesale Fees'])}
            </span>
            {report_new?.interchangeAndAcquirerFees ? (
              Object.entries(report_new?.interchangeAndAcquirerFees ?? {})
                .filter(([key, value]) => key !== 'Total I/C and Wholesale Fees' && value.length)
                ?.map(([key, value]) => (
                  <TableLayout noNegativeMargin isSearchBar={false} heading={key} currentPage={15} noPadding>
                    <Table
                      sameWidth
                      center
                      responsive={!responsive}
                      noPadding
                      rowsData={value.map(_ => [
                        _?.Description,
                        _?.['Rate %/Fee'],
                        formatCurrency(_?.Amount),
                        _?.Items,
                        formatCurrency(_?.['Total Fees']),
                      ])}
                      columnNames={['Card Type', 'Per Tran', 'Amount', 'Items', 'Total Charged']}
                      customWidth
                    />
                    <div
                      css={`
                        font-size: 1rem;
                        font-weight: 600;
                        text-align: left;
                        margin-top: 15px;
                      `}>
                      Total{' '}
                      {key
                        .split(' ')
                        .slice(0, 2)
                        .join(' ')
                        .replace(/^\w/, c => c.toUpperCase())}{' '}
                      Charge Fee:{' '}
                      {formatCurrency(
                        report_new?.interchangeAndAcquirerFees?.[key]?.reduce(
                          (acc, _) => acc + Number(_?.['Total Fees']?.toFixed(2)),
                          0,
                        ),
                      )}
                    </div>
                  </TableLayout>
                ))
            ) : (
              <TableLayout noNegativeMargin isSearchBar={false} currentPage={15} noPadding>
                <Table center noPadding rowsData={[]} columnNames={[]} customWidth responsive={!responsive} />
              </TableLayout>
            )}
          </div>
        )}

        {state.page === 1 && (
          <div className="table-wrap">
            <strong className="tables-heading">Other Fees & Charges</strong>
            <span
              css={`
                font-size: 1.2rem;
                font-weight: 600;
                margin-left: 20px;
              `}>
              Other Fees and Charges Fees Total:{' '}
              {formatCurrency(
                report_new?.monthlyFeesAndTaxes?.reduce((acc, _) => acc + (_['Total Fee Amount'] ?? 0), 0),
              )}
            </span>

            <TableLayout noNegativeMargin isSearchBar={false} currentPage={15}>
              <Table
                responsive={!responsive}
                noPadding
                rowsData={report_new?.monthlyFeesAndTaxes
                  ?.filter(_ => _?.Description)
                  .map(_ => [
                    _?.Description,
                    formatCurrency(Number(_?.['Fee Rate'])),
                    _?.Items,
                    _['Tax Applied'],
                    formatCurrency(_?.['Total Fee Amount']),
                  ])}
                columnNames={['Fee Name', 'Charge', 'Count', 'Tax Applied', 'Total Fee Amount']}
              />
            </TableLayout>
          </div>
        )}

        <div className="table-wrap">
          <strong className="tables-heading">Funding Summary</strong>
          <span
            css={`
              font-size: 1.2rem;
              font-weight: 600;
              margin-left: 20px;
            `}>
            Funding Summary Total:{' '}
            {formatCurrency(report_new?.deposits?.reduce((acc, _) => acc + Number(_?.Amount), 0))}
          </span>
          <TableLayout
            pagination={!print}
            noNegativeMargin
            hideItemsPerPage
            print={print}
            isSearchBar={false}
            currentPage={state.page}
            noPadding
            pageSize={state.pageSize}
            totalCount={report_new?.deposits?.length}
            onChangeFilters={_ => setState(__ => ({ ...__, ..._ }))}>
            <Table
              center
              responsive={!responsive}
              noPadding
              rowsData={funndingSummary}
              columnNames={funding_summary_col}
              customWidth
            />
          </TableLayout>
        </div>
      </StatementStyled>
    </Loaders>
  );
}

export default StatementDetailsV2;
